const changeNameStr = {
  toastr: 'Name changed',
  toastr1: 'name changed successfully'
};

export default changeNameStr;
